import { memo, useContext } from 'react';
import { twMerge } from 'tailwind-merge';
import { StepWidthWrapper } from 'react-scale/components/scalers/tasks/ThreadedInteraction/step/StepWidthWrapper';
import ContributorOverallFeedbackBox from 'react-scale/components/scalers/tasks/ThreadedInteraction/ContributorFeedback/components/ContributorOverallFeedbackBox';
import { useContributorFeedbackStore } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ContributorFeedback/stores/useContributorFeedbackStore';
import { getCanAddFeedback, getCanViewEditFeedback } from '@scale/shared/types/chat';
import { useChatStoreExtract } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';

type ContributorFeedbackHeaderProps = {
  className?: string;
};

const ContributorFeedbackHeader = memo(function ContributorFeedbackHeader({
  className,
}: ContributorFeedbackHeaderProps) {
  const reviewLevel = useChatStoreExtract(state => state.reviewLevel);
  const taskContext = useContext(ChatTaskContext);

  const feedback = useContributorFeedbackStore(s => s.feedback);

  const canAddFeedback = getCanAddFeedback({
    reviewLevel,

    // Overall task feedback is always read-only
    areCommentsReadOnly: true,
  });

  const canViewEditFeedback = getCanViewEditFeedback({
    feedback,
  });

  const shouldUseUnifiedFeedback =
    taskContext.enableUnifiedFeedback &&
    !taskContext.feedbackCenterMode &&
    (canAddFeedback || canViewEditFeedback);

  if (!shouldUseUnifiedFeedback) {
    return null;
  }

  return (
    <div className={twMerge('relative w-full', className)}>
      <StepWidthWrapper>
        <ContributorOverallFeedbackBox className="w-full" />
      </StepWidthWrapper>
    </div>
  );
});

export default ContributorFeedbackHeader;
